import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {toSnakeCase} from "../utils/general_utils";

const accordionSx = {
  p: 0,
  m: 0,
  bgcolor: 'transparent',
  boxShadow: 'none',
  '&:before': { display: 'none' }
};

const summaryBaseSx = {
  p: '8px 8px 8px 4px',
  flexDirection: 'row',
  alignItems: 'center',
  ml: 1,
  mr: 1,
  '& .MuiAccordionSummary-content': {
    m: 0,
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  borderRadius: 2,
  minHeight: '3px'
};

const CustomAccordion = ({
  descripcion = '',
  monto = '',
  contenido = { normal: '', bold: '' },
  bgcolor = '#D8431533',
  textColor = '#D84315',
  defaultExpanded = true
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Accordion disableGutters elevation={0} expanded={expanded} square sx={accordionSx}>
      <AccordionSummary test_id={toSnakeCase(descripcion)}
        onClick={() => setExpanded(prev => !prev)}
        sx={{ ...summaryBaseSx, backgroundColor: bgcolor }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <IconButton size="small" sx={{ mr: 1, p: 0 }}>
            <ExpandMoreIcon
              sx={{
                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease-in-out'
              }}
            />
          </IconButton>

          <Typography
            variant="body2"
            sx={{ color: textColor, flexGrow: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {descripcion}
          </Typography>

          <Typography variant="body2" sx={{ color: textColor, fontWeight: 'bold' }}>
            {monto}
          </Typography>
        </Box>
      </AccordionSummary>

      {expanded && (
        <AccordionDetails sx={{ py: 0 }}>
          <Typography variant="body2" color="textSecondary" sx={{ px: 1, py: 1 }}>
            {contenido.normal} <b>{contenido.bold}</b>
          </Typography>
        </AccordionDetails>
      )}
    </Accordion>
  );
};

export default CustomAccordion;
